import React from 'react';
import axios from "axios";
import {LOAD_FICHE_HISTORY, LOAD_STATE_HISTORIES} from "../../../api/Api";
import {getFileUrl} from "../../../utils/helpers";

export default function FichePlanRecolementViewer(props) {

    const {ficheId} = props;

    const [isLoadingHistory, setIsLoadingHistory] = React.useState(false);
    const [history, setHistory] = React.useState();

    async function loadHistory() {

        setIsLoadingHistory(true)

        try {

            const response = await axios.get(
                `${LOAD_STATE_HISTORIES}/${ficheId}`
            );

            console.log('loaded history', response.data);

            setHistory(response.data)

        } catch (e) {

        } finally {
            setIsLoadingHistory(false)
        }

    }

    React.useEffect(
        () => {

            loadHistory();

        }, []
    );

    const workFinishedStep = React.useMemo(
        () => {

            if (history) {

                const step = history.find(
                    item => item.new_state == 'App\\Models\\Fiches\\States\\WorkFinishedStep'
                )

                if (!step)
                    return undefined;

                return step;

            }

        }, [history]
    );

    if (!history || isLoadingHistory || !workFinishedStep)
        return null;

    return (
        <div className={'my-4'}>

            <div className={'text-primary h3'}>
                Plan de Recollement
            </div>

            <div className="row">

                {
                    workFinishedStep.update_datas.plan_recolement.map(
                        item => {
                            return (
                                <a target={'_blank'} href={getFileUrl(item)} className={'col-md-3 col-12'}>

                                    <div className={'btn btn-light-primary'}>
                                        <div className={'ml-3 btn btn-small btn-light-primary btn-sm btn-icon'}>
                                            <i className={'fa fa-download'} ></i>
                                        </div> Télécharger le plan de recollement
                                    </div>

                                </a>
                            )
                        }
                    )
                }


            </div>


        </div>
    );
}